import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { accessTokenAtom } from 'src/app/state/atoms';
import { PostMessageEvent, PostMessageEventType, PostMessageTypes } from 'src/types/iesAuth';

/**
 * Hook to initialize Auth process
 *
 * Once the tutor app is loaded we emit event to parent window
 * The parent has to listen for `authToken` type message and emit us back with IES Auth Token
 *
 * TODO: The `*` should be replaced with parent app environment URL
 */

function useAuthInit() {
  const [, setAccessToken] = useRecoilState(accessTokenAtom);

  useEffect(() => {
    window.parent.postMessage(
      {
        type: PostMessageEvent.ON_TUTOR_LOAD,
      },
      '*'
    );

    window.addEventListener(
      'message',
      (event: PostMessageEventType) => {
        if (event.data.type === PostMessageTypes.AUTH_TOKEN) {
          setAccessToken(event.data.authToken);

          // Notify parent back
          window.parent.postMessage(
            {
              type: PostMessageEvent.ON_TOKEN_RECEIVED,
            },
            '*'
          );
        }
      },
      false
    );
  }, [setAccessToken]);
}

export default useAuthInit;
